import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IWarehouseTransferInfo_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWarehouseTransferInfo_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  HS_TransferGetInfo: any[];
  HS_TransferGetInfo_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  isComp869753Visible: "visible" | "hidden";
  isComp606382Visible: "visible" | "hidden";
  isComp119724Visible: "visible" | "hidden";
  isComp367453Visible: "visible" | "hidden";
}

export class WarehouseTransferInfo_ScreenBase extends React.PureComponent<
  IWarehouseTransferInfo_ScreenProps,
  any
> {
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "262468e1-3d95-47bf-8a91-c7a01305498a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 869753, PropertyName: "value", Value: "Geçici Transfer Kodu" },
        { Id: 606382, PropertyName: "value", Value: "ERP Transfer Kodu" },
        { Id: 337787, PropertyName: "value", Value: "Sayılan Ürün Sayısı" },
        { Id: 538236, PropertyName: "value", Value: "Durum" },
        { Id: 483549, PropertyName: "value", Value: "Başlangıç Tarihi" },
        { Id: 988721, PropertyName: "value", Value: "Bitiş Tarihi" },
        { Id: 367453, PropertyName: "value", Value: "Devam Eden Sayım" },
        { Id: 985769, PropertyName: "value", Value: "Gönderen Ofis" },
        { Id: 990263, PropertyName: "value", Value: "Gönderen Depo" },
        { Id: 318603, PropertyName: "value", Value: "Gelen Ofis" },
        { Id: 356042, PropertyName: "value", Value: "Gelen Depo" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromLocalStorage: "",
      HS_TransferGetInfo: [],
      GoBack: "",
      isComp869753Visible: "hidden",
      isComp606382Visible: "hidden",
      isComp119724Visible: "hidden",
      isComp367453Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("warehousetransferinfo", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.WarehouseTransferInfoPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("warehousetransferinfo", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("warehousetransferinfo", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.WarehouseTransferInfoPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  WarehouseTransferInfoPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("TransferHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WarehouseTransferInfoPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferInfoPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferInfo/WarehouseTransferInfoPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_TransferGetInfo = result?.data.hS_TransferGetInfo;
    formVars.warehousetransferinfo_803531_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].transferNo
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].transferNo
        : null
    );
    formVars.warehousetransferinfo_546090_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].erpDocumentNo
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].erpDocumentNo
        : null
    );
    formVars.warehousetransferinfo_383066_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].totalTransferQty
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].totalTransferQty
        : null
    );
    formVars.warehousetransferinfo_332318_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].statuName
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].statuName
        : null
    );
    formVars.warehousetransferinfo_531119_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].transferDate
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].transferDate
        : null
    );
    formVars.warehousetransferinfo_119724_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].transferEndDate
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].transferEndDate
        : null
    );
    formVars.warehousetransferinfo_350135_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].officeCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].officeCode
        : null
    );
    formVars.warehousetransferinfo_587316_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].officeDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].officeDescription
        : null
    );
    formVars.warehousetransferinfo_982853_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].warehouseCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].warehouseCode
        : null
    );
    formVars.warehousetransferinfo_544018_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].warehouseDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].warehouseDescription
        : null
    );
    formVars.warehousetransferinfo_173773_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toOfficeCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toOfficeCode
        : null
    );
    formVars.warehousetransferinfo_488530_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toOfficeDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toOfficeDescription
        : null
    );
    formVars.warehousetransferinfo_667931_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toWarehouseCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toWarehouseCode
        : null
    );
    formVars.warehousetransferinfo_891225_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toWarehouseDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toWarehouseDescription
        : null
    );
    stateVars.isComp869753Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].erpDocumentNo
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp606382Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].erpDocumentNo
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp119724Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].transferEndDate
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].transferEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp367453Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].transferEndDate
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].transferEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WarehouseTransferInfoPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferInfoPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp869753Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].erpDocumentNo
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp606382Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].erpDocumentNo
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.warehousetransferinfo_803531_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].transferNo
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].transferNo
        : null
    );

    formVars.warehousetransferinfo_546090_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].erpDocumentNo
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].erpDocumentNo
        : null
    );

    formVars.warehousetransferinfo_383066_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].totalTransferQty
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].totalTransferQty
        : null
    );

    formVars.warehousetransferinfo_332318_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].statuName
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].statuName
        : null
    );

    formVars.warehousetransferinfo_531119_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].transferDate
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].transferDate
        : null
    );

    formVars.warehousetransferinfo_119724_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].transferEndDate
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].transferEndDate
        : null
    );

    stateVars.isComp119724Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].transferEndDate
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].transferEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp367453Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_TransferGetInfo !== undefined
            ? stateVars.HS_TransferGetInfo?.length > 0
              ? stateVars.HS_TransferGetInfo[0].transferEndDate
              : null
            : this.state.HS_TransferGetInfo?.length > 0
            ? this.state.HS_TransferGetInfo[0].transferEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.warehousetransferinfo_350135_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].officeCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].officeCode
        : null
    );

    formVars.warehousetransferinfo_587316_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].officeDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].officeDescription
        : null
    );

    formVars.warehousetransferinfo_982853_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].warehouseCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].warehouseCode
        : null
    );

    formVars.warehousetransferinfo_544018_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].warehouseDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].warehouseDescription
        : null
    );

    formVars.warehousetransferinfo_173773_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toOfficeCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toOfficeCode
        : null
    );

    formVars.warehousetransferinfo_488530_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toOfficeDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toOfficeDescription
        : null
    );

    formVars.warehousetransferinfo_667931_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toWarehouseCode
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toWarehouseCode
        : null
    );

    formVars.warehousetransferinfo_891225_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_TransferGetInfo !== undefined
        ? stateVars.HS_TransferGetInfo?.length > 0
          ? stateVars.HS_TransferGetInfo[0].toWarehouseDescription
          : null
        : this.state.HS_TransferGetInfo?.length > 0
        ? this.state.HS_TransferGetInfo[0].toWarehouseDescription
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  WarehouseTransferInfoComponent_60408_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.WarehouseTransferInfoPageInit();
    }
  }
}
